import { ModuleWithProviders, NgModule } from "@angular/core";
import { MapLocationSelectorComponent } from "./components/map/map-location-selector/map-location-selector.component";
import { MapsLoaderService } from "./services/maps-loader.service";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { GeoLocationService } from "./services/geo-location.service";
import { MapSearchComponent } from "./components/map/map-search/map-search.component";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from './components/loader/loader.component';
import { MyLocationBtnComponent } from './components/map/my-location-btn/my-location-btn.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToggleBtnComponent } from './components/common/toggle-btn/toggle-btn.component';
import { ModalComponent } from './components/common/modal/modal.component';
import { ModalHeaderComponent } from './components/common/modal-header/modal-header.component';
import { ModalBodyComponent } from './components/common/modal-body/modal-body.component';
import { ModalFooterComponent } from './components/common/modal-footer/modal-footer.component';
import { LabelValueLozengeComponent } from './components/common/label-value-lozenge/label-value-lozenge.component';
import { GeneralHistoryComponent } from "./components/general-history/general-history.component"; 
import { ActivityFeedComponent } from "./components/activity-feed/activity-feed.component";
import { DaysAgoPipe } from "./pipes/DaysAgoPipe";

//Shared components container
const SHARED_COMPONENTS = [
  MapLocationSelectorComponent,
  MapSearchComponent,
  MyLocationBtnComponent,
  LoaderComponent,
  ToggleBtnComponent,
  ModalComponent,
  ModalHeaderComponent,
  ModalBodyComponent,
  ModalFooterComponent,
  LabelValueLozengeComponent,
  ActivityFeedComponent,
  GeneralHistoryComponent,
  DaysAgoPipe
];

const MODULES = [
  CommonModule,
  NgxDropzoneModule
];

//Shared services container
const SHARED_SERVICES = [
  MapsLoaderService,
  GeoLocationService
];


@NgModule({
  declarations: [...SHARED_COMPONENTS],
  imports: [
    CommonModule,
    NgxDropzoneModule,
    NgbModule
  ],
  exports: [...SHARED_COMPONENTS],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        ...MODULES,
        ...SHARED_SERVICES
      ],
    };
  }
}
